import { styled } from "@styles";
import { Container, Row, Col, Card } from "react-bootstrap";

export const Wrapper = styled(Container)``;

export const Subtitle = styled.h3`
  font-size: .8rem;
  color: #888;
  margin-top: 1rem;
`;

export const MyPointPageCard = styled(Card)`
  width: 100%;
`;

export const BottomRow = styled(Row)`
  margin-top: 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
`;

export const BottomCol = styled(Col)`
  margin-top: 1.25rem;
`;

export const SummaryTitle = styled.h4`
  text-align: center;
  font-size: 1rem;
`;

export const SummaryValue = styled.p`
  color: #f39;
  font-size: 2rem;
  text-align: center;
`;

export const HeaderWrapper = styled.div``;

export const Header = styled.h2`
  text-transform: uppercase;
  text-align: center;
`;

export const NoDataCol = styled(Col)`
  text-align: center;
`;

export const NoData = styled.p`
  font-size: .8rem;
  color: #888;
  margin-top: 1rem;
`;